var jsOpenSearch = document.querySelector('#sooqrSearch');

jsOpenSearch.addEventListener('keyup', function () {
    var searchButton = document.querySelector('.search button');

    document.querySelector('body').classList.add('search-open');
    document.querySelector('.sooqrSearchContainer').style.display = 'block';
    searchButton.classList.add('close');
    searchButton.innerHTML = 'Sluiten';
});

document.querySelector('.search button').addEventListener('click', function () {
    if (this.classList.contains('close')) {
        var searchButton = document.querySelector('.search button');

        document.querySelector('body').classList.remove('search-open');
        document.querySelector('.sooqrSearchContainer').style.display = "none";
        document.querySelector('#sooqrSearch').value = "";
        searchButton.classList.remove('close');
        searchButton.innerHTML = 'Zoeken';
    }
});
